// import Swal from "sweetalert2";
// import toast from "sonner-js";

let started = false;
function init() {
  if (started) return;
  started = true;
  // @ts-expect-error
  sonnerJS.config({
    // theme: 'dark',
    toastOptions: {
      duration: 5000,
      richColors: true,
      position: "top-center",
      closeButton: true,
    },
  });
}

export function notify(
  message: string,
  type: "success" | "info" | "error" | "warning" | "removed" | "added" = "info",
) {
  init();
  switch (type) {
    case "success":
    case "info":
    case "error":
    case "warning":
      //@ts-expect-error
      sonnerJS[type](message, {
        duration: 5000,
      });
      break;
    case "removed":
    case "added":
      //@ts-expect-error
      sonnerJS.success(message, {
        duration: 0,
      });
      // Swal.fire({
      //   title: type === 'removed' ? 'Item Removed' : 'Item Added',
      //   text: message,
      //   icon: type === 'removed' ? 'warning' : 'success',
      // })
      break;
    default:
      //@ts-expect-error
      sonnerJS(message, {
        duration: 5000,
      });
  }
}
